export function isRequired(fieldName: string) {
	return `${fieldName} is required`;
}

export function mustBeNumber(fieldName: string, unit?: string) {
	const unitText = unit ? ` in ${unit}` : "";
	return `${fieldName} must be a valid number${unitText}`;
}

export function mustBePositive(fieldName: string) {
	return `${fieldName} must be a positive number`;
}

export function mustBeInRange(fieldName: string, min?: number, max?: number) {
	if (min !== undefined && max !== undefined) {
		return `${fieldName} must be between ${min} and ${max}`;
	}
	if (min !== undefined) {
		return `${fieldName} must be at least ${min}`;
	}
	if (max !== undefined) {
		return `${fieldName} must be no more than ${max}`;
	}
	return `${fieldName} is invalid`;
}

export function invalidFormat(fieldName: string, example?: string) {
	const exampleText = example ? ` (e.g., ${example})` : "";
	return `${fieldName} format is invalid${exampleText}`;
}

export function maxLength(fieldName: string, max: number) {
	return `${fieldName} must be no more than ${max} characters`;
}

export function minLength(fieldName: string, min: number) {
	return `${fieldName} must be at least ${min} characters`;
}
